import Head from "next/head";

import OverviewMain from "@/components/developers/overview-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Overview() {
  return (
    <>
      <Head>
        <title>{seoData.DEV_OVERVIEW.title}</title>
        <SeoMetaData data={seoData.DEV_OVERVIEW} />
      </Head>

      <OverviewMain />
    </>
  );
}
